import type {VerbisboxDataService} from './verbisbox.data-service';
import type {UUID} from 'typings/portaro.be.types';
import type {
    Box,
    BoxStation,
    StationLayout,
    ViewableStationState,
} from './types';
import type FinishedResponseInteractionService from '../commons/services/finished-response-interaction.service';

export class VerbisboxService {
    public static presenterName = 'verbisboxService';


    /*@ngInject*/
    constructor(private verbisboxDataService: VerbisboxDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    public async getStations(): Promise<BoxStation[]> {
        return this.verbisboxDataService.getStations();
    }

    public async getStation(id: UUID): Promise<BoxStation> {
        return this.verbisboxDataService.getStation(id);
    }

    public async getLayout(station: BoxStation): Promise<StationLayout> {
        return this.verbisboxDataService.getLayout(station);
    }

    public async getViewableState(station: BoxStation): Promise<ViewableStationState> {
        return this.getState(station);
    }

    public async requestServiceAccess(station: BoxStation, boxes: Box[]): Promise<void> {
        try {
            const response = await this.verbisboxDataService.createServiceAccess(station, boxes, true);
            await this.finishedResponseInteractionService.showSuccessResponseInModalWindow(response);
        } catch (error) {
            this.finishedResponseInteractionService.showFailedResponseInToast(error);
        }
    }

    public async requestNonPickingServiceAccess(station: BoxStation, boxes: Box[]): Promise<void> {
        try {
            const response = await this.verbisboxDataService.createServiceAccess(station, boxes, false);
            await this.finishedResponseInteractionService.showSuccessResponseInModalWindow(response);
        } catch (error) {
            this.finishedResponseInteractionService.showFailedResponseInToast(error);
        }
    }

    // private createViewableBox(box: Box, shipmentItemInfos: ShipmentItemInfo[]): ViewableBox {
    //     const viewableShipmentItems = box.items.map((item) => this.createViewableShipmentItem(item, shipmentItemInfos));
    //     return {...box, items: viewableShipmentItems};
    // }
    //
    // private createViewableShipmentItem(shipmentItem: ShipmentItem, shipmentItemInfos: ShipmentItemInfo[]): ViewableShipmentItem {
    //     return this.mergeToViewableShipmentItem(shipmentItem, this.getInfoById(shipmentItemInfos, shipmentItem.id));
    // }
    //
    // private mergeToViewableShipmentItem(shipmentItem: ShipmentItem, shipmentItemInfo: ShipmentItemInfo): ViewableShipmentItem {
    //     return {...shipmentItem, ...shipmentItemInfo};
    // }
    //
    // private getInfoById(infos: ShipmentItemInfo[], id: UUID): ShipmentItemInfo {
    //     return infos.find((info) => info.id === id);
    // }


    private async getState(station: BoxStation): Promise<ViewableStationState> {
        return this.verbisboxDataService.getState(station);
    }

    // private async getShipmentInfos(ids: UUID[]): Promise<ShipmentItemInfo[]> {
    //     return this.verbisboxDataService.getShipmentItemInfos(ids);
    // }
}